"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const ed5 = require("xmlchars/xml/1.0/ed5");
const ed2 = require("xmlchars/xml/1.1/ed2");
const NSed3 = require("xmlchars/xmlns/1.0/ed3");
var isS = ed5.isS;
var isChar10 = ed5.isChar;
var isNameStartChar = ed5.isNameStartChar;
var isNameChar = ed5.isNameChar;
var S_LIST = ed5.S_LIST;
var NAME_RE = ed5.NAME_RE;
var isChar11 = ed2.isChar;
var isNCNameStartChar = NSed3.isNCNameStartChar;
var isNCNameChar = NSed3.isNCNameChar;
var NC_NAME_RE = NSed3.NC_NAME_RE;
const XML_NAMESPACE = "http://www.w3.org/XML/1998/namespace";
const XMLNS_NAMESPACE = "http://www.w3.org/2000/xmlns/";
const rootNS = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  xml: XML_NAMESPACE,
  xmlns: XMLNS_NAMESPACE
};
const XML_ENTITIES = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  __proto__: null,
  amp: "&",
  gt: ">",
  lt: "<",
  quot: "\"",
  apos: "'"
};
// EOC: end-of-chunk
const EOC = -1;
const NL_LIKE = -2;
const S_BEGIN = 0; // Initial state.
const S_BEGIN_WHITESPACE = 1; // leading whitespace
const S_DOCTYPE = 2; // <!DOCTYPE
const S_DOCTYPE_QUOTE = 3; // <!DOCTYPE "//blah
const S_DTD = 4; // <!DOCTYPE "//blah" [ ...
const S_DTD_QUOTED = 5; // <!DOCTYPE "//blah" [ "foo
const S_DTD_OPEN_WAKA = 6;
const S_DTD_OPEN_WAKA_BANG = 7;
const S_DTD_COMMENT = 8; // <!--
const S_DTD_COMMENT_ENDING = 9; // <!-- blah -
const S_DTD_COMMENT_ENDED = 10; // <!-- blah --
const S_DTD_PI = 11; // <?
const S_DTD_PI_ENDING = 12; // <?hi "there" ?
const S_TEXT = 13; // general stuff
const S_ENTITY = 14; // &amp and such
const S_OPEN_WAKA = 15; // <
const S_OPEN_WAKA_BANG = 16; // <!...
const S_COMMENT = 17; // <!--
const S_COMMENT_ENDING = 18; // <!-- blah -
const S_COMMENT_ENDED = 19; // <!-- blah --
const S_CDATA = 20; // <![CDATA[ something
const S_CDATA_ENDING = 21; // ]
const S_CDATA_ENDING_2 = 22; // ]]
const S_PI_FIRST_CHAR = 23; // <?hi, first char
const S_PI_REST = 24; // <?hi, rest of the name
const S_PI_BODY = 25; // <?hi there
const S_PI_ENDING = 26; // <?hi "there" ?
const S_XML_DECL_NAME_START = 27; // <?xml
const S_XML_DECL_NAME = 28; // <?xml foo
const S_XML_DECL_EQ = 29; // <?xml foo=
const S_XML_DECL_VALUE_START = 30; // <?xml foo=
const S_XML_DECL_VALUE = 31; // <?xml foo="bar"
const S_XML_DECL_SEPARATOR = 32; // <?xml foo="bar"
const S_XML_DECL_ENDING = 33; // <?xml ... ?
const S_OPEN_TAG = 34; // <strong
const S_OPEN_TAG_SLASH = 35; // <strong /
const S_ATTRIB = 36; // <a
const S_ATTRIB_NAME = 37; // <a foo
const S_ATTRIB_NAME_SAW_WHITE = 38; // <a foo _
const S_ATTRIB_VALUE = 39; // <a foo=
const S_ATTRIB_VALUE_QUOTED = 40; // <a foo="bar
const S_ATTRIB_VALUE_CLOSED = 41; // <a foo="bar"
const S_ATTRIB_VALUE_UNQUOTED = 42; // <a foo=bar
const S_CLOSE_TAG = 43; // </a
const S_CLOSE_TAG_SAW_WHITE = 44; // </a   >
const TAB = 9;
const NL = 0xA;
const CR = 0xD;
const SPACE = 0x20;
const BANG = 0x21;
const DQUOTE = 0x22;
const AMP = 0x26;
const SQUOTE = 0x27;
const MINUS = 0x2D;
const FORWARD_SLASH = 0x2F;
const SEMICOLON = 0x3B;
const LESS = 0x3C;
const EQUAL = 0x3D;
const GREATER = 0x3E;
const QUESTION = 0x3F;
const OPEN_BRACKET = 0x5B;
const CLOSE_BRACKET = 0x5D;
const NEL = 0x85;
const LS = 0x2028; // Line Separator
const isQuote = c => c === DQUOTE || c === SQUOTE;
const QUOTES = [DQUOTE, SQUOTE];
const DOCTYPE_TERMINATOR = [...QUOTES, OPEN_BRACKET, GREATER];
const DTD_TERMINATOR = [...QUOTES, LESS, CLOSE_BRACKET];
const XML_DECL_NAME_TERMINATOR = [EQUAL, QUESTION, ...S_LIST];
const ATTRIB_VALUE_UNQUOTED_TERMINATOR = [...S_LIST, GREATER, AMP, LESS];
function nsPairCheck(parser, prefix, uri) {
  switch (prefix) {
    case "xml":
      if (uri !== XML_NAMESPACE) {
        parser.fail(`xml prefix must be bound to ${XML_NAMESPACE}.`);
      }
      break;
    case "xmlns":
      if (uri !== XMLNS_NAMESPACE) {
        parser.fail(`xmlns prefix must be bound to ${XMLNS_NAMESPACE}.`);
      }
      break;
    default:
  }
  switch (uri) {
    case XMLNS_NAMESPACE:
      parser.fail(prefix === "" ? `the default namespace may not be set to ${uri}.` : `may not assign a prefix (even "xmlns") to the URI \
${XMLNS_NAMESPACE}.`);
      break;
    case XML_NAMESPACE:
      switch (prefix) {
        case "xml":
          // Assinging the XML namespace to "xml" is fine.
          break;
        case "":
          parser.fail(`the default namespace may not be set to ${uri}.`);
          break;
        default:
          parser.fail("may not assign the xml namespace to another prefix.");
      }
      break;
    default:
  }
}
function nsMappingCheck(parser, mapping) {
  for (const local of Object.keys(mapping)) {
    nsPairCheck(parser, local, mapping[local]);
  }
}
const isNCName = name => NC_NAME_RE.test(name);
const isName = name => NAME_RE.test(name);
const FORBIDDEN_START = 0;
const FORBIDDEN_BRACKET = 1;
const FORBIDDEN_BRACKET_BRACKET = 2;
/**
 * The list of supported events.
 */
exports.EVENTS = ["xmldecl", "text", "processinginstruction", "doctype", "comment", "opentagstart", "attribute", "opentag", "closetag", "cdata", "error", "end", "ready"];
const EVENT_NAME_TO_HANDLER_NAME = {
  xmldecl: "xmldeclHandler",
  text: "textHandler",
  processinginstruction: "piHandler",
  doctype: "doctypeHandler",
  comment: "commentHandler",
  opentagstart: "openTagStartHandler",
  attribute: "attributeHandler",
  opentag: "openTagHandler",
  closetag: "closeTagHandler",
  cdata: "cdataHandler",
  error: "errorHandler",
  end: "endHandler",
  ready: "readyHandler"
};
class SaxesParser {
  /**
   * @param opt The parser options.
   */
  constructor(opt) {
    this.opt = opt !== null && opt !== void 0 ? opt : {};
    this.fragmentOpt = !!this.opt.fragment;
    const xmlnsOpt = this.xmlnsOpt = !!this.opt.xmlns;
    this.trackPosition = this.opt.position !== false;
    this.fileName = this.opt.fileName;
    if (xmlnsOpt) {
      // This is the function we use to perform name checks on PIs and entities.
      // When namespaces are used, colons are not allowed in PI target names or
      // entity names. So the check depends on whether namespaces are used. See:
      //
      // https://www.w3.org/XML/xml-names-19990114-errata.html
      // NE08
      //
      this.nameStartCheck = isNCNameStartChar;
      this.nameCheck = isNCNameChar;
      this.isName = isNCName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsNS;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribNS;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.ns = Object.assign({
        __proto__: null
      }, rootNS);
      const additional = this.opt.additionalNamespaces;
      if (additional != null) {
        nsMappingCheck(this, additional);
        Object.assign(this.ns, additional);
      }
    } else {
      this.nameStartCheck = isNameStartChar;
      this.nameCheck = isNameChar;
      this.isName = isName;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.processAttribs = this.processAttribsPlain;
      // eslint-disable-next-line @typescript-eslint/unbound-method
      this.pushAttrib = this.pushAttribPlain;
    }
    //
    // The order of the members in this table needs to correspond to the state
    // numbers given to the states that correspond to the methods being recorded
    // here.
    //
    this.stateTable = [/* eslint-disable @typescript-eslint/unbound-method */
    this.sBegin, this.sBeginWhitespace, this.sDoctype, this.sDoctypeQuote, this.sDTD, this.sDTDQuoted, this.sDTDOpenWaka, this.sDTDOpenWakaBang, this.sDTDComment, this.sDTDCommentEnding, this.sDTDCommentEnded, this.sDTDPI, this.sDTDPIEnding, this.sText, this.sEntity, this.sOpenWaka, this.sOpenWakaBang, this.sComment, this.sCommentEnding, this.sCommentEnded, this.sCData, this.sCDataEnding, this.sCDataEnding2, this.sPIFirstChar, this.sPIRest, this.sPIBody, this.sPIEnding, this.sXMLDeclNameStart, this.sXMLDeclName, this.sXMLDeclEq, this.sXMLDeclValueStart, this.sXMLDeclValue, this.sXMLDeclSeparator, this.sXMLDeclEnding, this.sOpenTag, this.sOpenTagSlash, this.sAttrib, this.sAttribName, this.sAttribNameSawWhite, this.sAttribValue, this.sAttribValueQuoted, this.sAttribValueClosed, this.sAttribValueUnquoted, this.sCloseTag, this.sCloseTagSawWhite];
    this._init();
  }
  /**
   * Indicates whether or not the parser is closed. If ``true``, wait for
   * the ``ready`` event to write again.
   */
  get closed() {
    return this._closed;
  }
  _init() {
    var _a;
    this.openWakaBang = "";
    this.text = "";
    this.name = "";
    this.piTarget = "";
    this.entity = "";
    this.q = null;
    this.tags = [];
    this.tag = null;
    this.topNS = null;
    this.chunk = "";
    this.chunkPosition = 0;
    this.i = 0;
    this.prevI = 0;
    this.carriedFromPrevious = undefined;
    this.forbiddenState = FORBIDDEN_START;
    this.attribList = [];
    // The logic is organized so as to minimize the need to check
    // this.opt.fragment while parsing.
    const {
      fragmentOpt
    } = this;
    this.state = fragmentOpt ? S_TEXT : S_BEGIN;
    // We want these to be all true if we are dealing with a fragment.
    this.reportedTextBeforeRoot = this.reportedTextAfterRoot = this.closedRoot = this.sawRoot = fragmentOpt;
    // An XML declaration is intially possible only when parsing whole
    // documents.
    this.xmlDeclPossible = !fragmentOpt;
    this.xmlDeclExpects = ["version"];
    this.entityReturnState = undefined;
    let {
      defaultXMLVersion
    } = this.opt;
    if (defaultXMLVersion === undefined) {
      if (this.opt.forceXMLVersion === true) {
        throw new Error("forceXMLVersion set but defaultXMLVersion is not set");
      }
      defaultXMLVersion = "1.0";
    }
    this.setXMLVersion(defaultXMLVersion);
    this.positionAtNewLine = 0;
    this.doctype = false;
    this._closed = false;
    this.xmlDecl = {
      version: undefined,
      encoding: undefined,
      standalone: undefined
    };
    this.line = 1;
    this.column = 0;
    this.ENTITIES = Object.create(XML_ENTITIES);
    // eslint-disable-next-line no-unused-expressions
    (_a = this.readyHandler) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  /**
   * The stream position the parser is currently looking at. This field is
   * zero-based.
   *
   * This field is not based on counting Unicode characters but is to be
   * interpreted as a plain index into a JavaScript string.
   */
  get position() {
    return this.chunkPosition + this.i;
  }
  /**
   * The column number of the next character to be read by the parser.  *
   * This field is zero-based. (The first column in a line is 0.)
   *
   * This field reports the index at which the next character would be in the
   * line if the line were represented as a JavaScript string.  Note that this
   * *can* be different to a count based on the number of *Unicode characters*
   * due to how JavaScript handles astral plane characters.
   *
   * See [[column]] for a number that corresponds to a count of Unicode
   * characters.
   */
  get columnIndex() {
    return this.position - this.positionAtNewLine;
  }
  /**
   * Set an event listener on an event. The parser supports one handler per
   * event type. If you try to set an event handler over an existing handler,
   * the old handler is silently overwritten.
   *
   * @param name The event to listen to.
   *
   * @param handler The handler to set.
   */
  on(name, handler) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this[EVENT_NAME_TO_HANDLER_NAME[name]] = handler;
  }
  /**
   * Unset an event handler.
   *
   * @parma name The event to stop listening to.
   */
  off(name) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this[EVENT_NAME_TO_HANDLER_NAME[name]] = undefined;
  }
  /**
   * Make an error object. The error object will have a message that contains
   * the ``fileName`` option passed at the creation of the parser. If position
   * tracking was turned on, it will also have line and column number
   * information.
   *
   * @param message The message describing the error to report.
   *
   * @returns An error object with a properly formatted message.
   */
  makeError(message) {
    var _a;
    let msg = (_a = this.fileName) !== null && _a !== void 0 ? _a : "";
    if (this.trackPosition) {
      if (msg.length > 0) {
        msg += ":";
      }
      msg += `${this.line}:${this.column}`;
    }
    if (msg.length > 0) {
      msg += ": ";
    }
    return new Error(msg + message);
  }
  /**
   * Report a parsing error. This method is made public so that client code may
   * check for issues that are outside the scope of this project and can report
   * errors.
   *
   * @param message The error to report.
   *
   * @returns this
   */
  fail(message) {
    const err = this.makeError(message);
    const handler = this.errorHandler;
    if (handler === undefined) {
      throw err;
    } else {
      handler(err);
    }
    return this;
  }
  /**
   * Write a XML data to the parser.
   *
   * @param chunk The XML data to write.
   *
   * @returns this
   */
  write(chunk) {
    if (this.closed) {
      return this.fail("cannot write after close; assign an onready handler.");
    }
    let end = false;
    if (chunk === null) {
      // We cannot return immediately because carriedFromPrevious may need
      // processing.
      end = true;
      chunk = "";
    } else if (typeof chunk === "object") {
      chunk = chunk.toString();
    }
    // We checked if performing a pre-decomposition of the string into an array
    // of single complete characters (``Array.from(chunk)``) would be faster
    // than the current repeated calls to ``charCodeAt``. As of August 2018, it
    // isn't. (There may be Node-specific code that would perform faster than
    // ``Array.from`` but don't want to be dependent on Node.)
    if (this.carriedFromPrevious !== undefined) {
      // The previous chunk had char we must carry over.
      chunk = `${this.carriedFromPrevious}${chunk}`;
      this.carriedFromPrevious = undefined;
    }
    let limit = chunk.length;
    const lastCode = chunk.charCodeAt(limit - 1);
    if (!end && (
    // A trailing CR or surrogate must be carried over to the next
    // chunk.
    lastCode === CR || lastCode >= 0xD800 && lastCode <= 0xDBFF)) {
      // The chunk ends with a character that must be carried over. We cannot
      // know how to handle it until we get the next chunk or the end of the
      // stream. So save it for later.
      this.carriedFromPrevious = chunk[limit - 1];
      limit--;
      chunk = chunk.slice(0, limit);
    }
    const {
      stateTable
    } = this;
    this.chunk = chunk;
    this.i = 0;
    while (this.i < limit) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      stateTable[this.state].call(this);
    }
    this.chunkPosition += limit;
    return end ? this.end() : this;
  }
  /**
   * Close the current stream. Perform final well-formedness checks and reset
   * the parser tstate.
   *
   * @returns this
   */
  close() {
    return this.write(null);
  }
  /**
   * Get a single code point out of the current chunk. This updates the current
   * position if we do position tracking.
   *
   * This is the algorithm to use for XML 1.0.
   *
   * @returns The character read.
   */
  getCode10() {
    const {
      chunk,
      i
    } = this;
    this.prevI = i;
    // Yes, we do this instead of doing this.i++. Doing it this way, we do not
    // read this.i again, which is a bit faster.
    this.i = i + 1;
    if (i >= chunk.length) {
      return EOC;
    }
    // Using charCodeAt and handling the surrogates ourselves is faster
    // than using codePointAt.
    const code = chunk.charCodeAt(i);
    this.column++;
    if (code < 0xD800) {
      if (code >= SPACE || code === TAB) {
        return code;
      }
      switch (code) {
        case NL:
          this.line++;
          this.column = 0;
          this.positionAtNewLine = this.position;
          return NL;
        case CR:
          // We may get NaN if we read past the end of the chunk, which is fine.
          if (chunk.charCodeAt(i + 1) === NL) {
            // A \r\n sequence is converted to \n so we have to skip over the
            // next character. We already know it has a size of 1 so ++ is fine
            // here.
            this.i = i + 2;
          }
          // Otherwise, a \r is just converted to \n, so we don't have to skip
          // ahead.
          // In either case, \r becomes \n.
          this.line++;
          this.column = 0;
          this.positionAtNewLine = this.position;
          return NL_LIKE;
        default:
          // If we get here, then code < SPACE and it is not NL CR or TAB.
          this.fail("disallowed character.");
          return code;
      }
    }
    if (code > 0xDBFF) {
      // This is a specialized version of isChar10 that takes into account
      // that in this context code > 0xDBFF and code <= 0xFFFF. So it does not
      // test cases that don't need testing.
      if (!(code >= 0xE000 && code <= 0xFFFD)) {
        this.fail("disallowed character.");
      }
      return code;
    }
    const final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
    this.i = i + 2;
    // This is a specialized version of isChar10 that takes into account that in
    // this context necessarily final >= 0x10000.
    if (final > 0x10FFFF) {
      this.fail("disallowed character.");
    }
    return final;
  }
  /**
   * Get a single code point out of the current chunk. This updates the current
   * position if we do position tracking.
   *
   * This is the algorithm to use for XML 1.1.
   *
   * @returns {number} The character read.
   */
  getCode11() {
    const {
      chunk,
      i
    } = this;
    this.prevI = i;
    // Yes, we do this instead of doing this.i++. Doing it this way, we do not
    // read this.i again, which is a bit faster.
    this.i = i + 1;
    if (i >= chunk.length) {
      return EOC;
    }
    // Using charCodeAt and handling the surrogates ourselves is faster
    // than using codePointAt.
    const code = chunk.charCodeAt(i);
    this.column++;
    if (code < 0xD800) {
      if (code > 0x1F && code < 0x7F || code > 0x9F && code !== LS || code === TAB) {
        return code;
      }
      switch (code) {
        case NL:
          // 0xA
          this.line++;
          this.column = 0;
          this.positionAtNewLine = this.position;
          return NL;
        case CR:
          {
            // 0xD
            // We may get NaN if we read past the end of the chunk, which is
            // fine.
            const next = chunk.charCodeAt(i + 1);
            if (next === NL || next === NEL) {
              // A CR NL or CR NEL sequence is converted to NL so we have to skip
              // over the next character. We already know it has a size of 1.
              this.i = i + 2;
            }
            // Otherwise, a CR is just converted to NL, no skip.
          }
        /* yes, fall through */
        case NEL: // 0x85
        case LS:
          // Ox2028
          this.line++;
          this.column = 0;
          this.positionAtNewLine = this.position;
          return NL_LIKE;
        default:
          this.fail("disallowed character.");
          return code;
      }
    }
    if (code > 0xDBFF) {
      // This is a specialized version of isCharAndNotRestricted that takes into
      // account that in this context code > 0xDBFF and code <= 0xFFFF. So it
      // does not test cases that don't need testing.
      if (!(code >= 0xE000 && code <= 0xFFFD)) {
        this.fail("disallowed character.");
      }
      return code;
    }
    const final = 0x10000 + (code - 0xD800) * 0x400 + (chunk.charCodeAt(i + 1) - 0xDC00);
    this.i = i + 2;
    // This is a specialized version of isCharAndNotRestricted that takes into
    // account that in this context necessarily final >= 0x10000.
    if (final > 0x10FFFF) {
      this.fail("disallowed character.");
    }
    return final;
  }
  /**
   * Like ``getCode`` but with the return value normalized so that ``NL`` is
   * returned for ``NL_LIKE``.
   */
  getCodeNorm() {
    const c = this.getCode();
    return c === NL_LIKE ? NL : c;
  }
  unget() {
    this.i = this.prevI;
    this.column--;
  }
  /**
   * Capture characters into a buffer until encountering one of a set of
   * characters.
   *
   * @param chars An array of codepoints. Encountering a character in the array
   * ends the capture. (``chars`` may safely contain ``NL``.)
   *
   * @return The character code that made the capture end, or ``EOC`` if we hit
   * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
   * instead.
   */
  captureTo(chars) {
    let {
      i: start
    } = this;
    const {
      chunk
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const c = this.getCode();
      const isNLLike = c === NL_LIKE;
      const final = isNLLike ? NL : c;
      if (final === EOC || chars.includes(final)) {
        this.text += chunk.slice(start, this.prevI);
        return final;
      }
      if (isNLLike) {
        this.text += `${chunk.slice(start, this.prevI)}\n`;
        start = this.i;
      }
    }
  }
  /**
   * Capture characters into a buffer until encountering a character.
   *
   * @param char The codepoint that ends the capture. **NOTE ``char`` MAY NOT
   * CONTAIN ``NL``.** Passing ``NL`` will result in buggy behavior.
   *
   * @return ``true`` if we ran into the character. Otherwise, we ran into the
   * end of the current chunk.
   */
  captureToChar(char) {
    let {
      i: start
    } = this;
    const {
      chunk
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      let c = this.getCode();
      switch (c) {
        case NL_LIKE:
          this.text += `${chunk.slice(start, this.prevI)}\n`;
          start = this.i;
          c = NL;
          break;
        case EOC:
          this.text += chunk.slice(start);
          return false;
        default:
      }
      if (c === char) {
        this.text += chunk.slice(start, this.prevI);
        return true;
      }
    }
  }
  /**
   * Capture characters that satisfy ``isNameChar`` into the ``name`` field of
   * this parser.
   *
   * @return The character code that made the test fail, or ``EOC`` if we hit
   * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
   * instead.
   */
  captureNameChars() {
    const {
      chunk,
      i: start
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const c = this.getCode();
      if (c === EOC) {
        this.name += chunk.slice(start);
        return EOC;
      }
      // NL is not a name char so we don't have to test specifically for it.
      if (!isNameChar(c)) {
        this.name += chunk.slice(start, this.prevI);
        return c === NL_LIKE ? NL : c;
      }
    }
  }
  /**
   * Skip white spaces.
   *
   * @return The character that ended the skip, or ``EOC`` if we hit
   * the end of the chunk. The return value cannot be NL_LIKE: NL is returned
   * instead.
   */
  skipSpaces() {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const c = this.getCodeNorm();
      if (c === EOC || !isS(c)) {
        return c;
      }
    }
  }
  setXMLVersion(version) {
    this.currentXMLVersion = version;
    /*  eslint-disable @typescript-eslint/unbound-method */
    if (version === "1.0") {
      this.isChar = isChar10;
      this.getCode = this.getCode10;
    } else {
      this.isChar = isChar11;
      this.getCode = this.getCode11;
    }
    /* eslint-enable @typescript-eslint/unbound-method */
  }
  // STATE ENGINE METHODS
  // This needs to be a state separate from S_BEGIN_WHITESPACE because we want
  // to be sure never to come back to this state later.
  sBegin() {
    // We are essentially peeking at the first character of the chunk. Since
    // S_BEGIN can be in effect only when we start working on the first chunk,
    // the index at which we must look is necessarily 0. Note also that the
    // following test does not depend on decoding surrogates.
    // If the initial character is 0xFEFF, ignore it.
    if (this.chunk.charCodeAt(0) === 0xFEFF) {
      this.i++;
      this.column++;
    }
    this.state = S_BEGIN_WHITESPACE;
  }
  sBeginWhitespace() {
    // We need to know whether we've encountered spaces or not because as soon
    // as we run into a space, an XML declaration is no longer possible. Rather
    // than slow down skipSpaces even in places where we don't care whether it
    // skipped anything or not, we check whether prevI is equal to the value of
    // i from before we skip spaces.
    const iBefore = this.i;
    const c = this.skipSpaces();
    if (this.prevI !== iBefore) {
      this.xmlDeclPossible = false;
    }
    switch (c) {
      case LESS:
        this.state = S_OPEN_WAKA;
        // We could naively call closeText but in this state, it is not normal
        // to have text be filled with any data.
        if (this.text.length !== 0) {
          throw new Error("no-empty text at start");
        }
        break;
      case EOC:
        break;
      default:
        this.unget();
        this.state = S_TEXT;
        this.xmlDeclPossible = false;
    }
  }
  sDoctype() {
    var _a;
    const c = this.captureTo(DOCTYPE_TERMINATOR);
    switch (c) {
      case GREATER:
        {
          // eslint-disable-next-line no-unused-expressions
          (_a = this.doctypeHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
          this.text = "";
          this.state = S_TEXT;
          this.doctype = true; // just remember that we saw it.
          break;
        }
      case EOC:
        break;
      default:
        this.text += String.fromCodePoint(c);
        if (c === OPEN_BRACKET) {
          this.state = S_DTD;
        } else if (isQuote(c)) {
          this.state = S_DOCTYPE_QUOTE;
          this.q = c;
        }
    }
  }
  sDoctypeQuote() {
    const q = this.q;
    if (this.captureToChar(q)) {
      this.text += String.fromCodePoint(q);
      this.q = null;
      this.state = S_DOCTYPE;
    }
  }
  sDTD() {
    const c = this.captureTo(DTD_TERMINATOR);
    if (c === EOC) {
      return;
    }
    this.text += String.fromCodePoint(c);
    if (c === CLOSE_BRACKET) {
      this.state = S_DOCTYPE;
    } else if (c === LESS) {
      this.state = S_DTD_OPEN_WAKA;
    } else if (isQuote(c)) {
      this.state = S_DTD_QUOTED;
      this.q = c;
    }
  }
  sDTDQuoted() {
    const q = this.q;
    if (this.captureToChar(q)) {
      this.text += String.fromCodePoint(q);
      this.state = S_DTD;
      this.q = null;
    }
  }
  sDTDOpenWaka() {
    const c = this.getCodeNorm();
    this.text += String.fromCodePoint(c);
    switch (c) {
      case BANG:
        this.state = S_DTD_OPEN_WAKA_BANG;
        this.openWakaBang = "";
        break;
      case QUESTION:
        this.state = S_DTD_PI;
        break;
      default:
        this.state = S_DTD;
    }
  }
  sDTDOpenWakaBang() {
    const char = String.fromCodePoint(this.getCodeNorm());
    const owb = this.openWakaBang += char;
    this.text += char;
    if (owb !== "-") {
      this.state = owb === "--" ? S_DTD_COMMENT : S_DTD;
      this.openWakaBang = "";
    }
  }
  sDTDComment() {
    if (this.captureToChar(MINUS)) {
      this.text += "-";
      this.state = S_DTD_COMMENT_ENDING;
    }
  }
  sDTDCommentEnding() {
    const c = this.getCodeNorm();
    this.text += String.fromCodePoint(c);
    this.state = c === MINUS ? S_DTD_COMMENT_ENDED : S_DTD_COMMENT;
  }
  sDTDCommentEnded() {
    const c = this.getCodeNorm();
    this.text += String.fromCodePoint(c);
    if (c === GREATER) {
      this.state = S_DTD;
    } else {
      this.fail("malformed comment.");
      // <!-- blah -- bloo --> will be recorded as
      // a comment of " blah -- bloo "
      this.state = S_DTD_COMMENT;
    }
  }
  sDTDPI() {
    if (this.captureToChar(QUESTION)) {
      this.text += "?";
      this.state = S_DTD_PI_ENDING;
    }
  }
  sDTDPIEnding() {
    const c = this.getCodeNorm();
    this.text += String.fromCodePoint(c);
    if (c === GREATER) {
      this.state = S_DTD;
    }
  }
  sText() {
    //
    // We did try a version of saxes where the S_TEXT state was split in two
    // states: one for text inside the root element, and one for text
    // outside. This was avoiding having to test this.tags.length to decide
    // what implementation to actually use.
    //
    // Peformance testing on gigabyte-size files did not show any advantage to
    // using the two states solution instead of the current one. Conversely, it
    // made the code a bit more complicated elsewhere. For instance, a comment
    // can appear before the root element so when a comment ended it was
    // necessary to determine whether to return to the S_TEXT state or to the
    // new text-outside-root state.
    //
    if (this.tags.length !== 0) {
      this.handleTextInRoot();
    } else {
      this.handleTextOutsideRoot();
    }
  }
  sEntity() {
    // This is essentially a specialized version of captureToChar(SEMICOLON...)
    let {
      i: start
    } = this;
    const {
      chunk
    } = this;
    // eslint-disable-next-line no-labels, no-restricted-syntax
    loop:
    // eslint-disable-next-line no-constant-condition
    while (true) {
      switch (this.getCode()) {
        case NL_LIKE:
          this.entity += `${chunk.slice(start, this.prevI)}\n`;
          start = this.i;
          break;
        case SEMICOLON:
          {
            const {
              entityReturnState
            } = this;
            const entity = this.entity + chunk.slice(start, this.prevI);
            this.state = entityReturnState;
            let parsed;
            if (entity === "") {
              this.fail("empty entity name.");
              parsed = "&;";
            } else {
              parsed = this.parseEntity(entity);
              this.entity = "";
            }
            if (entityReturnState !== S_TEXT || this.textHandler !== undefined) {
              this.text += parsed;
            }
            // eslint-disable-next-line no-labels
            break loop;
          }
        case EOC:
          this.entity += chunk.slice(start);
          // eslint-disable-next-line no-labels
          break loop;
        default:
      }
    }
  }
  sOpenWaka() {
    // Reminder: a state handler is called with at least one character
    // available in the current chunk. So the first call to get code inside of
    // a state handler cannot return ``EOC``. That's why we don't test
    // for it.
    const c = this.getCode();
    // either a /, ?, !, or text is coming next.
    if (isNameStartChar(c)) {
      this.state = S_OPEN_TAG;
      this.unget();
      this.xmlDeclPossible = false;
    } else {
      switch (c) {
        case FORWARD_SLASH:
          this.state = S_CLOSE_TAG;
          this.xmlDeclPossible = false;
          break;
        case BANG:
          this.state = S_OPEN_WAKA_BANG;
          this.openWakaBang = "";
          this.xmlDeclPossible = false;
          break;
        case QUESTION:
          this.state = S_PI_FIRST_CHAR;
          break;
        default:
          this.fail("disallowed character in tag name");
          this.state = S_TEXT;
          this.xmlDeclPossible = false;
      }
    }
  }
  sOpenWakaBang() {
    this.openWakaBang += String.fromCodePoint(this.getCodeNorm());
    switch (this.openWakaBang) {
      case "[CDATA[":
        if (!this.sawRoot && !this.reportedTextBeforeRoot) {
          this.fail("text data outside of root node.");
          this.reportedTextBeforeRoot = true;
        }
        if (this.closedRoot && !this.reportedTextAfterRoot) {
          this.fail("text data outside of root node.");
          this.reportedTextAfterRoot = true;
        }
        this.state = S_CDATA;
        this.openWakaBang = "";
        break;
      case "--":
        this.state = S_COMMENT;
        this.openWakaBang = "";
        break;
      case "DOCTYPE":
        this.state = S_DOCTYPE;
        if (this.doctype || this.sawRoot) {
          this.fail("inappropriately located doctype declaration.");
        }
        this.openWakaBang = "";
        break;
      default:
        // 7 happens to be the maximum length of the string that can possibly
        // match one of the cases above.
        if (this.openWakaBang.length >= 7) {
          this.fail("incorrect syntax.");
        }
    }
  }
  sComment() {
    if (this.captureToChar(MINUS)) {
      this.state = S_COMMENT_ENDING;
    }
  }
  sCommentEnding() {
    var _a;
    const c = this.getCodeNorm();
    if (c === MINUS) {
      this.state = S_COMMENT_ENDED;
      // eslint-disable-next-line no-unused-expressions
      (_a = this.commentHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
      this.text = "";
    } else {
      this.text += `-${String.fromCodePoint(c)}`;
      this.state = S_COMMENT;
    }
  }
  sCommentEnded() {
    const c = this.getCodeNorm();
    if (c !== GREATER) {
      this.fail("malformed comment.");
      // <!-- blah -- bloo --> will be recorded as
      // a comment of " blah -- bloo "
      this.text += `--${String.fromCodePoint(c)}`;
      this.state = S_COMMENT;
    } else {
      this.state = S_TEXT;
    }
  }
  sCData() {
    if (this.captureToChar(CLOSE_BRACKET)) {
      this.state = S_CDATA_ENDING;
    }
  }
  sCDataEnding() {
    const c = this.getCodeNorm();
    if (c === CLOSE_BRACKET) {
      this.state = S_CDATA_ENDING_2;
    } else {
      this.text += `]${String.fromCodePoint(c)}`;
      this.state = S_CDATA;
    }
  }
  sCDataEnding2() {
    var _a;
    const c = this.getCodeNorm();
    switch (c) {
      case GREATER:
        {
          // eslint-disable-next-line no-unused-expressions
          (_a = this.cdataHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.text);
          this.text = "";
          this.state = S_TEXT;
          break;
        }
      case CLOSE_BRACKET:
        this.text += "]";
        break;
      default:
        this.text += `]]${String.fromCodePoint(c)}`;
        this.state = S_CDATA;
    }
  }
  // We need this separate state to check the first character fo the pi target
  // with this.nameStartCheck which allows less characters than this.nameCheck.
  sPIFirstChar() {
    const c = this.getCodeNorm();
    // This is first because in the case where the file is well-formed this is
    // the branch taken. We optimize for well-formedness.
    if (this.nameStartCheck(c)) {
      this.piTarget += String.fromCodePoint(c);
      this.state = S_PI_REST;
    } else if (c === QUESTION || isS(c)) {
      this.fail("processing instruction without a target.");
      this.state = c === QUESTION ? S_PI_ENDING : S_PI_BODY;
    } else {
      this.fail("disallowed character in processing instruction name.");
      this.piTarget += String.fromCodePoint(c);
      this.state = S_PI_REST;
    }
  }
  sPIRest() {
    // Capture characters into a piTarget while ``this.nameCheck`` run on the
    // character read returns true.
    const {
      chunk,
      i: start
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const c = this.getCodeNorm();
      if (c === EOC) {
        this.piTarget += chunk.slice(start);
        return;
      }
      // NL cannot satisfy this.nameCheck so we don't have to test specifically
      // for it.
      if (!this.nameCheck(c)) {
        this.piTarget += chunk.slice(start, this.prevI);
        const isQuestion = c === QUESTION;
        if (isQuestion || isS(c)) {
          if (this.piTarget === "xml") {
            if (!this.xmlDeclPossible) {
              this.fail("an XML declaration must be at the start of the document.");
            }
            this.state = isQuestion ? S_XML_DECL_ENDING : S_XML_DECL_NAME_START;
          } else {
            this.state = isQuestion ? S_PI_ENDING : S_PI_BODY;
          }
        } else {
          this.fail("disallowed character in processing instruction name.");
          this.piTarget += String.fromCodePoint(c);
        }
        break;
      }
    }
  }
  sPIBody() {
    if (this.text.length === 0) {
      const c = this.getCodeNorm();
      if (c === QUESTION) {
        this.state = S_PI_ENDING;
      } else if (!isS(c)) {
        this.text = String.fromCodePoint(c);
      }
    }
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    else if (this.captureToChar(QUESTION)) {
      this.state = S_PI_ENDING;
    }
  }
  sPIEnding() {
    var _a;
    const c = this.getCodeNorm();
    if (c === GREATER) {
      const {
        piTarget
      } = this;
      if (piTarget.toLowerCase() === "xml") {
        this.fail("the XML declaration must appear at the start of the document.");
      }
      // eslint-disable-next-line no-unused-expressions
      (_a = this.piHandler) === null || _a === void 0 ? void 0 : _a.call(this, {
        target: piTarget,
        body: this.text
      });
      this.piTarget = this.text = "";
      this.state = S_TEXT;
    } else if (c === QUESTION) {
      // We ran into ?? as part of a processing instruction. We initially took
      // the first ? as a sign that the PI was ending, but it is not. So we have
      // to add it to the body but we take the new ? as a sign that the PI is
      // ending.
      this.text += "?";
    } else {
      this.text += `?${String.fromCodePoint(c)}`;
      this.state = S_PI_BODY;
    }
    this.xmlDeclPossible = false;
  }
  sXMLDeclNameStart() {
    const c = this.skipSpaces();
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      // It is valid to go to S_XML_DECL_ENDING from this state.
      this.state = S_XML_DECL_ENDING;
      return;
    }
    if (c !== EOC) {
      this.state = S_XML_DECL_NAME;
      this.name = String.fromCodePoint(c);
    }
  }
  sXMLDeclName() {
    const c = this.captureTo(XML_DECL_NAME_TERMINATOR);
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      this.state = S_XML_DECL_ENDING;
      this.name += this.text;
      this.text = "";
      this.fail("XML declaration is incomplete.");
      return;
    }
    if (!(isS(c) || c === EQUAL)) {
      return;
    }
    this.name += this.text;
    this.text = "";
    if (!this.xmlDeclExpects.includes(this.name)) {
      switch (this.name.length) {
        case 0:
          this.fail("did not expect any more name/value pairs.");
          break;
        case 1:
          this.fail(`expected the name ${this.xmlDeclExpects[0]}.`);
          break;
        default:
          this.fail(`expected one of ${this.xmlDeclExpects.join(", ")}`);
      }
    }
    this.state = c === EQUAL ? S_XML_DECL_VALUE_START : S_XML_DECL_EQ;
  }
  sXMLDeclEq() {
    const c = this.getCodeNorm();
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      this.state = S_XML_DECL_ENDING;
      this.fail("XML declaration is incomplete.");
      return;
    }
    if (isS(c)) {
      return;
    }
    if (c !== EQUAL) {
      this.fail("value required.");
    }
    this.state = S_XML_DECL_VALUE_START;
  }
  sXMLDeclValueStart() {
    const c = this.getCodeNorm();
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      this.state = S_XML_DECL_ENDING;
      this.fail("XML declaration is incomplete.");
      return;
    }
    if (isS(c)) {
      return;
    }
    if (!isQuote(c)) {
      this.fail("value must be quoted.");
      this.q = SPACE;
    } else {
      this.q = c;
    }
    this.state = S_XML_DECL_VALUE;
  }
  sXMLDeclValue() {
    const c = this.captureTo([this.q, QUESTION]);
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      this.state = S_XML_DECL_ENDING;
      this.text = "";
      this.fail("XML declaration is incomplete.");
      return;
    }
    if (c === EOC) {
      return;
    }
    const value = this.text;
    this.text = "";
    switch (this.name) {
      case "version":
        {
          this.xmlDeclExpects = ["encoding", "standalone"];
          const version = value;
          this.xmlDecl.version = version;
          // This is the test specified by XML 1.0 but it is fine for XML 1.1.
          if (!/^1\.[0-9]+$/.test(version)) {
            this.fail("version number must match /^1\\.[0-9]+$/.");
          }
          // When forceXMLVersion is set, the XML declaration is ignored.
          else if (!this.opt.forceXMLVersion) {
            this.setXMLVersion(version);
          }
          break;
        }
      case "encoding":
        if (!/^[A-Za-z][A-Za-z0-9._-]*$/.test(value)) {
          this.fail("encoding value must match \
/^[A-Za-z0-9][A-Za-z0-9._-]*$/.");
        }
        this.xmlDeclExpects = ["standalone"];
        this.xmlDecl.encoding = value;
        break;
      case "standalone":
        if (value !== "yes" && value !== "no") {
          this.fail("standalone value must match \"yes\" or \"no\".");
        }
        this.xmlDeclExpects = [];
        this.xmlDecl.standalone = value;
        break;
      default:
      // We don't need to raise an error here since we've already raised one
      // when checking what name was expected.
    }
    this.name = "";
    this.state = S_XML_DECL_SEPARATOR;
  }
  sXMLDeclSeparator() {
    const c = this.getCodeNorm();
    // The question mark character is not valid inside any of the XML
    // declaration name/value pairs.
    if (c === QUESTION) {
      // It is valid to go to S_XML_DECL_ENDING from this state.
      this.state = S_XML_DECL_ENDING;
      return;
    }
    if (!isS(c)) {
      this.fail("whitespace required.");
      this.unget();
    }
    this.state = S_XML_DECL_NAME_START;
  }
  sXMLDeclEnding() {
    var _a;
    const c = this.getCodeNorm();
    if (c === GREATER) {
      if (this.piTarget !== "xml") {
        this.fail("processing instructions are not allowed before root.");
      } else if (this.name !== "version" && this.xmlDeclExpects.includes("version")) {
        this.fail("XML declaration must contain a version.");
      }
      // eslint-disable-next-line no-unused-expressions
      (_a = this.xmldeclHandler) === null || _a === void 0 ? void 0 : _a.call(this, this.xmlDecl);
      this.name = "";
      this.piTarget = this.text = "";
      this.state = S_TEXT;
    } else {
      // We got here because the previous character was a ?, but the question
      // mark character is not valid inside any of the XML declaration
      // name/value pairs.
      this.fail("The character ? is disallowed anywhere in XML declarations.");
    }
    this.xmlDeclPossible = false;
  }
  sOpenTag() {
    var _a;
    const c = this.captureNameChars();
    if (c === EOC) {
      return;
    }
    const tag = this.tag = {
      name: this.name,
      attributes: Object.create(null)
    };
    this.name = "";
    if (this.xmlnsOpt) {
      this.topNS = tag.ns = Object.create(null);
    }
    // eslint-disable-next-line no-unused-expressions
    (_a = this.openTagStartHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
    this.sawRoot = true;
    if (!this.fragmentOpt && this.closedRoot) {
      this.fail("documents may contain only one root.");
    }
    switch (c) {
      case GREATER:
        this.openTag();
        break;
      case FORWARD_SLASH:
        this.state = S_OPEN_TAG_SLASH;
        break;
      default:
        if (!isS(c)) {
          this.fail("disallowed character in tag name.");
        }
        this.state = S_ATTRIB;
    }
  }
  sOpenTagSlash() {
    if (this.getCode() === GREATER) {
      this.openSelfClosingTag();
    } else {
      this.fail("forward-slash in opening tag not followed by >.");
      this.state = S_ATTRIB;
    }
  }
  sAttrib() {
    const c = this.skipSpaces();
    if (c === EOC) {
      return;
    }
    if (isNameStartChar(c)) {
      this.unget();
      this.state = S_ATTRIB_NAME;
    } else if (c === GREATER) {
      this.openTag();
    } else if (c === FORWARD_SLASH) {
      this.state = S_OPEN_TAG_SLASH;
    } else {
      this.fail("disallowed character in attribute name.");
    }
  }
  sAttribName() {
    const c = this.captureNameChars();
    if (c === EQUAL) {
      this.state = S_ATTRIB_VALUE;
    } else if (isS(c)) {
      this.state = S_ATTRIB_NAME_SAW_WHITE;
    } else if (c === GREATER) {
      this.fail("attribute without value.");
      this.pushAttrib(this.name, this.name);
      this.name = this.text = "";
      this.openTag();
    } else if (c !== EOC) {
      this.fail("disallowed character in attribute name.");
    }
  }
  sAttribNameSawWhite() {
    const c = this.skipSpaces();
    switch (c) {
      case EOC:
        return;
      case EQUAL:
        this.state = S_ATTRIB_VALUE;
        break;
      default:
        this.fail("attribute without value.");
        // Should we do this???
        // this.tag.attributes[this.name] = "";
        this.text = "";
        this.name = "";
        if (c === GREATER) {
          this.openTag();
        } else if (isNameStartChar(c)) {
          this.unget();
          this.state = S_ATTRIB_NAME;
        } else {
          this.fail("disallowed character in attribute name.");
          this.state = S_ATTRIB;
        }
    }
  }
  sAttribValue() {
    const c = this.getCodeNorm();
    if (isQuote(c)) {
      this.q = c;
      this.state = S_ATTRIB_VALUE_QUOTED;
    } else if (!isS(c)) {
      this.fail("unquoted attribute value.");
      this.state = S_ATTRIB_VALUE_UNQUOTED;
      this.unget();
    }
  }
  sAttribValueQuoted() {
    // We deliberately do not use captureTo here. The specialized code we use
    // here is faster than using captureTo.
    const {
      q,
      chunk
    } = this;
    let {
      i: start
    } = this;
    // eslint-disable-next-line no-constant-condition
    while (true) {
      switch (this.getCode()) {
        case q:
          this.pushAttrib(this.name, this.text + chunk.slice(start, this.prevI));
          this.name = this.text = "";
          this.q = null;
          this.state = S_ATTRIB_VALUE_CLOSED;
          return;
        case AMP:
          this.text += chunk.slice(start, this.prevI);
          this.state = S_ENTITY;
          this.entityReturnState = S_ATTRIB_VALUE_QUOTED;
          return;
        case NL:
        case NL_LIKE:
        case TAB:
          this.text += `${chunk.slice(start, this.prevI)} `;
          start = this.i;
          break;
        case LESS:
          this.text += chunk.slice(start, this.prevI);
          this.fail("disallowed character.");
          return;
        case EOC:
          this.text += chunk.slice(start);
          return;
        default:
      }
    }
  }
  sAttribValueClosed() {
    const c = this.getCodeNorm();
    if (isS(c)) {
      this.state = S_ATTRIB;
    } else if (c === GREATER) {
      this.openTag();
    } else if (c === FORWARD_SLASH) {
      this.state = S_OPEN_TAG_SLASH;
    } else if (isNameStartChar(c)) {
      this.fail("no whitespace between attributes.");
      this.unget();
      this.state = S_ATTRIB_NAME;
    } else {
      this.fail("disallowed character in attribute name.");
    }
  }
  sAttribValueUnquoted() {
    // We don't do anything regarding EOL or space handling for unquoted
    // attributes. We already have failed by the time we get here, and the
    // contract that saxes upholds states that upon failure, it is not safe to
    // rely on the data passed to event handlers (other than
    // ``onerror``). Passing "bad" data is not a problem.
    const c = this.captureTo(ATTRIB_VALUE_UNQUOTED_TERMINATOR);
    switch (c) {
      case AMP:
        this.state = S_ENTITY;
        this.entityReturnState = S_ATTRIB_VALUE_UNQUOTED;
        break;
      case LESS:
        this.fail("disallowed character.");
        break;
      case EOC:
        break;
      default:
        if (this.text.includes("]]>")) {
          this.fail("the string \"]]>\" is disallowed in char data.");
        }
        this.pushAttrib(this.name, this.text);
        this.name = this.text = "";
        if (c === GREATER) {
          this.openTag();
        } else {
          this.state = S_ATTRIB;
        }
    }
  }
  sCloseTag() {
    const c = this.captureNameChars();
    if (c === GREATER) {
      this.closeTag();
    } else if (isS(c)) {
      this.state = S_CLOSE_TAG_SAW_WHITE;
    } else if (c !== EOC) {
      this.fail("disallowed character in closing tag.");
    }
  }
  sCloseTagSawWhite() {
    switch (this.skipSpaces()) {
      case GREATER:
        this.closeTag();
        break;
      case EOC:
        break;
      default:
        this.fail("disallowed character in closing tag.");
    }
  }
  // END OF STATE ENGINE METHODS
  handleTextInRoot() {
    // This is essentially a specialized version of captureTo which is optimized
    // for performing the ]]> check. A previous version of this code, checked
    // ``this.text`` for the presence of ]]>. It simplified the code but was
    // very costly when character data contained a lot of entities to be parsed.
    //
    // Since we are using a specialized loop, we also keep track of the presence
    // of ]]> in text data. The sequence ]]> is forbidden to appear as-is.
    //
    let {
      i: start,
      forbiddenState
    } = this;
    const {
      chunk,
      textHandler: handler
    } = this;
    // eslint-disable-next-line no-labels, no-restricted-syntax
    scanLoop:
    // eslint-disable-next-line no-constant-condition
    while (true) {
      switch (this.getCode()) {
        case LESS:
          {
            this.state = S_OPEN_WAKA;
            if (handler !== undefined) {
              const {
                text
              } = this;
              const slice = chunk.slice(start, this.prevI);
              if (text.length !== 0) {
                handler(text + slice);
                this.text = "";
              } else if (slice.length !== 0) {
                handler(slice);
              }
            }
            forbiddenState = FORBIDDEN_START;
            // eslint-disable-next-line no-labels
            break scanLoop;
          }
        case AMP:
          this.state = S_ENTITY;
          this.entityReturnState = S_TEXT;
          if (handler !== undefined) {
            this.text += chunk.slice(start, this.prevI);
          }
          forbiddenState = FORBIDDEN_START;
          // eslint-disable-next-line no-labels
          break scanLoop;
        case CLOSE_BRACKET:
          switch (forbiddenState) {
            case FORBIDDEN_START:
              forbiddenState = FORBIDDEN_BRACKET;
              break;
            case FORBIDDEN_BRACKET:
              forbiddenState = FORBIDDEN_BRACKET_BRACKET;
              break;
            case FORBIDDEN_BRACKET_BRACKET:
              break;
            default:
              throw new Error("impossible state");
          }
          break;
        case GREATER:
          if (forbiddenState === FORBIDDEN_BRACKET_BRACKET) {
            this.fail("the string \"]]>\" is disallowed in char data.");
          }
          forbiddenState = FORBIDDEN_START;
          break;
        case NL_LIKE:
          if (handler !== undefined) {
            this.text += `${chunk.slice(start, this.prevI)}\n`;
          }
          start = this.i;
          forbiddenState = FORBIDDEN_START;
          break;
        case EOC:
          if (handler !== undefined) {
            this.text += chunk.slice(start);
          }
          // eslint-disable-next-line no-labels
          break scanLoop;
        default:
          forbiddenState = FORBIDDEN_START;
      }
    }
    this.forbiddenState = forbiddenState;
  }
  handleTextOutsideRoot() {
    // This is essentially a specialized version of captureTo which is optimized
    // for a specialized task. We keep track of the presence of non-space
    // characters in the text since these are errors when appearing outside the
    // document root element.
    let {
      i: start
    } = this;
    const {
      chunk,
      textHandler: handler
    } = this;
    let nonSpace = false;
    // eslint-disable-next-line no-labels, no-restricted-syntax
    outRootLoop:
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const code = this.getCode();
      switch (code) {
        case LESS:
          {
            this.state = S_OPEN_WAKA;
            if (handler !== undefined) {
              const {
                text
              } = this;
              const slice = chunk.slice(start, this.prevI);
              if (text.length !== 0) {
                handler(text + slice);
                this.text = "";
              } else if (slice.length !== 0) {
                handler(slice);
              }
            }
            // eslint-disable-next-line no-labels
            break outRootLoop;
          }
        case AMP:
          this.state = S_ENTITY;
          this.entityReturnState = S_TEXT;
          if (handler !== undefined) {
            this.text += chunk.slice(start, this.prevI);
          }
          nonSpace = true;
          // eslint-disable-next-line no-labels
          break outRootLoop;
        case NL_LIKE:
          if (handler !== undefined) {
            this.text += `${chunk.slice(start, this.prevI)}\n`;
          }
          start = this.i;
          break;
        case EOC:
          if (handler !== undefined) {
            this.text += chunk.slice(start);
          }
          // eslint-disable-next-line no-labels
          break outRootLoop;
        default:
          if (!isS(code)) {
            nonSpace = true;
          }
      }
    }
    if (!nonSpace) {
      return;
    }
    // We use the reportedTextBeforeRoot and reportedTextAfterRoot flags
    // to avoid reporting errors for every single character that is out of
    // place.
    if (!this.sawRoot && !this.reportedTextBeforeRoot) {
      this.fail("text data outside of root node.");
      this.reportedTextBeforeRoot = true;
    }
    if (this.closedRoot && !this.reportedTextAfterRoot) {
      this.fail("text data outside of root node.");
      this.reportedTextAfterRoot = true;
    }
  }
  pushAttribNS(name, value) {
    var _a;
    const {
      prefix,
      local
    } = this.qname(name);
    const attr = {
      name,
      prefix,
      local,
      value
    };
    this.attribList.push(attr);
    // eslint-disable-next-line no-unused-expressions
    (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
    if (prefix === "xmlns") {
      const trimmed = value.trim();
      if (this.currentXMLVersion === "1.0" && trimmed === "") {
        this.fail("invalid attempt to undefine prefix in XML 1.0");
      }
      this.topNS[local] = trimmed;
      nsPairCheck(this, local, trimmed);
    } else if (name === "xmlns") {
      const trimmed = value.trim();
      this.topNS[""] = trimmed;
      nsPairCheck(this, "", trimmed);
    }
  }
  pushAttribPlain(name, value) {
    var _a;
    const attr = {
      name,
      value
    };
    this.attribList.push(attr);
    // eslint-disable-next-line no-unused-expressions
    (_a = this.attributeHandler) === null || _a === void 0 ? void 0 : _a.call(this, attr);
  }
  /**
   * End parsing. This performs final well-formedness checks and resets the
   * parser to a clean state.
   *
   * @returns this
   */
  end() {
    var _a, _b;
    if (!this.sawRoot) {
      this.fail("document must contain a root element.");
    }
    const {
      tags
    } = this;
    while (tags.length > 0) {
      const tag = tags.pop();
      this.fail(`unclosed tag: ${tag.name}`);
    }
    if (this.state !== S_BEGIN && this.state !== S_TEXT) {
      this.fail("unexpected end.");
    }
    const {
      text
    } = this;
    if (text.length !== 0) {
      // eslint-disable-next-line no-unused-expressions
      (_a = this.textHandler) === null || _a === void 0 ? void 0 : _a.call(this, text);
      this.text = "";
    }
    this._closed = true;
    // eslint-disable-next-line no-unused-expressions
    (_b = this.endHandler) === null || _b === void 0 ? void 0 : _b.call(this);
    this._init();
    return this;
  }
  /**
   * Resolve a namespace prefix.
   *
   * @param prefix The prefix to resolve.
   *
   * @returns The namespace URI or ``undefined`` if the prefix is not defined.
   */
  resolve(prefix) {
    var _a, _b;
    let uri = this.topNS[prefix];
    if (uri !== undefined) {
      return uri;
    }
    const {
      tags
    } = this;
    for (let index = tags.length - 1; index >= 0; index--) {
      uri = tags[index].ns[prefix];
      if (uri !== undefined) {
        return uri;
      }
    }
    uri = this.ns[prefix];
    if (uri !== undefined) {
      return uri;
    }
    return (_b = (_a = this.opt).resolvePrefix) === null || _b === void 0 ? void 0 : _b.call(_a, prefix);
  }
  /**
   * Parse a qname into its prefix and local name parts.
   *
   * @param name The name to parse
   *
   * @returns
   */
  qname(name) {
    // This is faster than using name.split(":").
    const colon = name.indexOf(":");
    if (colon === -1) {
      return {
        prefix: "",
        local: name
      };
    }
    const local = name.slice(colon + 1);
    const prefix = name.slice(0, colon);
    if (prefix === "" || local === "" || local.includes(":")) {
      this.fail(`malformed name: ${name}.`);
    }
    return {
      prefix,
      local
    };
  }
  processAttribsNS() {
    var _a;
    const {
      attribList
    } = this;
    const tag = this.tag;
    {
      // add namespace info to tag
      const {
        prefix,
        local
      } = this.qname(tag.name);
      tag.prefix = prefix;
      tag.local = local;
      const uri = tag.uri = (_a = this.resolve(prefix)) !== null && _a !== void 0 ? _a : "";
      if (prefix !== "") {
        if (prefix === "xmlns") {
          this.fail("tags may not have \"xmlns\" as prefix.");
        }
        if (uri === "") {
          this.fail(`unbound namespace prefix: ${JSON.stringify(prefix)}.`);
          tag.uri = prefix;
        }
      }
    }
    if (attribList.length === 0) {
      return;
    }
    const {
      attributes
    } = tag;
    const seen = new Set();
    // Note: do not apply default ns to attributes:
    //   http://www.w3.org/TR/REC-xml-names/#defaulting
    for (const attr of attribList) {
      const {
        name,
        prefix,
        local
      } = attr;
      let uri;
      let eqname;
      if (prefix === "") {
        uri = name === "xmlns" ? XMLNS_NAMESPACE : "";
        eqname = name;
      } else {
        uri = this.resolve(prefix);
        // if there's any attributes with an undefined namespace,
        // then fail on them now.
        if (uri === undefined) {
          this.fail(`unbound namespace prefix: ${JSON.stringify(prefix)}.`);
          uri = prefix;
        }
        eqname = `{${uri}}${local}`;
      }
      if (seen.has(eqname)) {
        this.fail(`duplicate attribute: ${eqname}.`);
      }
      seen.add(eqname);
      attr.uri = uri;
      attributes[name] = attr;
    }
    this.attribList = [];
  }
  processAttribsPlain() {
    const {
      attribList
    } = this;
    // eslint-disable-next-line prefer-destructuring
    const attributes = this.tag.attributes;
    for (const {
      name,
      value
    } of attribList) {
      if (attributes[name] !== undefined) {
        this.fail(`duplicate attribute: ${name}.`);
      }
      attributes[name] = value;
    }
    this.attribList = [];
  }
  /**
   * Handle a complete open tag. This parser code calls this once it has seen
   * the whole tag. This method checks for well-formeness and then emits
   * ``onopentag``.
   */
  openTag() {
    var _a;
    this.processAttribs();
    const {
      tags
    } = this;
    const tag = this.tag;
    tag.isSelfClosing = false;
    // There cannot be any pending text here due to the onopentagstart that was
    // necessarily emitted before we get here. So we do not check text.
    // eslint-disable-next-line no-unused-expressions
    (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
    tags.push(tag);
    this.state = S_TEXT;
    this.name = "";
  }
  /**
   * Handle a complete self-closing tag. This parser code calls this once it has
   * seen the whole tag. This method checks for well-formeness and then emits
   * ``onopentag`` and ``onclosetag``.
   */
  openSelfClosingTag() {
    var _a, _b, _c;
    this.processAttribs();
    const {
      tags
    } = this;
    const tag = this.tag;
    tag.isSelfClosing = true;
    // There cannot be any pending text here due to the onopentagstart that was
    // necessarily emitted before we get here. So we do not check text.
    // eslint-disable-next-line no-unused-expressions
    (_a = this.openTagHandler) === null || _a === void 0 ? void 0 : _a.call(this, tag);
    // eslint-disable-next-line no-unused-expressions
    (_b = this.closeTagHandler) === null || _b === void 0 ? void 0 : _b.call(this, tag);
    const top = this.tag = (_c = tags[tags.length - 1]) !== null && _c !== void 0 ? _c : null;
    if (top === null) {
      this.closedRoot = true;
    }
    this.state = S_TEXT;
    this.name = "";
  }
  /**
   * Handle a complete close tag. This parser code calls this once it has seen
   * the whole tag. This method checks for well-formeness and then emits
   * ``onclosetag``.
   */
  closeTag() {
    const {
      tags,
      name
    } = this;
    // Our state after this will be S_TEXT, no matter what, and we can clear
    // tagName now.
    this.state = S_TEXT;
    this.name = "";
    if (name === "") {
      this.fail("weird empty close tag.");
      this.text += "</>";
      return;
    }
    const handler = this.closeTagHandler;
    let l = tags.length;
    while (l-- > 0) {
      const tag = this.tag = tags.pop();
      this.topNS = tag.ns;
      // eslint-disable-next-line no-unused-expressions
      handler === null || handler === void 0 ? void 0 : handler(tag);
      if (tag.name === name) {
        break;
      }
      this.fail("unexpected close tag.");
    }
    if (l === 0) {
      this.closedRoot = true;
    } else if (l < 0) {
      this.fail(`unmatched closing tag: ${name}.`);
      this.text += `</${name}>`;
    }
  }
  /**
   * Resolves an entity. Makes any necessary well-formedness checks.
   *
   * @param entity The entity to resolve.
   *
   * @returns The parsed entity.
   */
  parseEntity(entity) {
    // startsWith would be significantly slower for this test.
    // eslint-disable-next-line @typescript-eslint/prefer-string-starts-ends-with
    if (entity[0] !== "#") {
      const defined = this.ENTITIES[entity];
      if (defined !== undefined) {
        return defined;
      }
      this.fail(this.isName(entity) ? "undefined entity." : "disallowed character in entity name.");
      return `&${entity};`;
    }
    let num = NaN;
    if (entity[1] === "x" && /^#x[0-9a-f]+$/i.test(entity)) {
      num = parseInt(entity.slice(2), 16);
    } else if (/^#[0-9]+$/.test(entity)) {
      num = parseInt(entity.slice(1), 10);
    }
    // The character reference is required to match the CHAR production.
    if (!this.isChar(num)) {
      this.fail("malformed character entity.");
      return `&${entity};`;
    }
    return String.fromCodePoint(num);
  }
}
exports.SaxesParser = SaxesParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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